<script>
import StringUtils from '@/utils/stringUtils'
export default
{
    name: 'labelled-border',

    props:
    {
        labelRetracted: { type: Boolean, default: true }
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='labelled-border'>
                    <div ref='borderLeft' class='border left' />
                    <div ref='borderBottom' class='border bottom' />
                    <div ref='borderRight' class='border right' />
                    <div ref='borderTop' class='border top' />
                    <div class='content'>
                        { this.$slots.default }
                    </div>
                    <div class='error-message'>{this.errorMessage}</div>
            </div>
        )
    },

    mounted ()
    {
        this.borders.left = this.$refs.borderLeft
        this.borders.top = this.$refs.borderTop
        this.borders.right = this.$refs.borderRight
        this.borders.bottom = this.$refs.borderBottom
        
        window.addEventListener('resize', this.resize)
        window.addEventListener('focus', this.resizeLate, {passive: true, capture: true})
        this.$el.addEventListener('click', this.onElementClicked)

        this.resize()

        this.observer = new MutationObserver((mutations, observer) =>
        {
            if (mutations[0].target != this.$slots.default[0].elm)
            {
                const label = this.$el.querySelector('.label')
                if (label)
                {
                    label.style.transition = 'none'
                    setTimeout(() => label.style.transition = '', 300)
                }
            }

            setTimeout(this.resize, 50)
            setTimeout(this.resize, 200)
        })
        this.observer.observe(document.body, { childList: true, subtree: true })
    },

    data () 
    {
        return {
            observer: null,
            isLabelRetracted: this.labelRetracted,
            labelInitialPos: { top: 0, left: 0 },
            borders: { left: null, top: null, right: null, bottom: null },
            errorMessage: '',
            lastResizeTimestamp: 0,
        }
    },

    computed:
    {
    },

    watch:
    {
        labelRetracted ()
        {
            this.isLabelRetracted = this.labelRetracted
        },

        isLabelRetracted ()
        {
            this.onIsLabelRectractedChanged()
        },

        errorMessage ()
        {
            if (StringUtils.isEmptyString(this.errorMessage))
            {
                this.$el.classList.remove('has-error')
            }
            else this.$el.classList.add('has-error')
        }
    },

    beforeDestroy ()
    {
        this.observer.disconnect()
        window.removeEventListener('resize', this.resize)
        window.removeEventListener('focus', this.resizeLate)
        this.$el.removeEventListener('click', this.onElementClicked)
    },

    methods:
    {
        resize ()
        {
            if (Date.now() - this.lastResizeTimestamp < 40) return
            this.lastResizeTimestamp = Date.now()

            const padding = 20
            const rect = JSON.parse(JSON.stringify(this.$el.querySelector('.content').getBoundingClientRect()))
            rect.y += scrollY
            rect.top += scrollY
            rect.bottom += scrollY
            const style = window.getComputedStyle(this.borders.top)
            const borderWidth =
            {
                top: Number.parseFloat(style.borderTopWidth),
                right: Number.parseFloat(style.borderRightWidth),
                bottom: Number.parseFloat(window.getComputedStyle(this.borders.bottom).borderBottomWidth),
                left: Number.parseFloat(style.borderLeftWidth),
            }

            if (!this.borders.left)
            {
                if (this.observer) this.observer.disconnect()
                
                return
            }

            this.borders.left.style.left = rect.left + 'px'
            this.borders.left.style.top = rect.top + 'px'
            this.borders.left.style.height = rect.height - (borderWidth.top + borderWidth.bottom) + 'px'
            this.borders.left.style.width = padding - borderWidth.left + 'px'

            this.borders.bottom.style.top = rect.bottom - borderWidth.top - padding + 'px'
            this.borders.bottom.style.left = rect.left + 'px'
            this.borders.bottom.style.width = rect.width - (borderWidth.left + borderWidth.right * 2) + 'px'
            this.borders.bottom.style.height = padding +'px'

            this.borders.right.style.left = rect.right - padding - borderWidth.right + 'px'
            this.borders.right.style.top = rect.top + 'px'
            this.borders.right.style.height = rect.height - (borderWidth.top + borderWidth.bottom) + 'px'
            this.borders.right.style.width = padding - borderWidth.right +'px'

            this.borders.top.style.top = rect.top + 'px'
            this.borders.top.style.left = rect.left + 'px'
            this.borders.top.style.width = rect.width - (borderWidth.left + borderWidth.right * 2) + 'px'
            this.borders.top.style.height = padding + 'px'

            const label = this.$el.querySelector('.label')
            this.labelInitialPos = { top: label.offsetTop, left: label.offsetLeft }
            this.onIsLabelRectractedChanged()
        },

        resizeLate ()
        {
            setTimeout(this.resize, 10)
        },

        onIsLabelRectractedChanged ()
        {
            if (this.isLabelRetracted) this.retractLabel()
            else this.expandLabel()
        },

        retractLabel ()
        {
            const fontSize = 12
            const label = this.$el.querySelector('.label')
            const borderTop = this.borders.top
            if (!borderTop) return

            const borderLeft = this.borders.left
            const borderWidth = window.getComputedStyle(borderTop).borderWidth

            label.style.position = 'absolute'
            label.style.fontSize = fontSize + 'px'
            label.style.width = 'auto'
            label.style.padding = '0 8px'
            label.style.marginLeft = '30px'
            label.style.left = Number.parseFloat(borderTop.style.left) - Number.parseFloat(borderLeft.style.width) + 'px'
            label.style.top = Number.parseFloat(borderTop.style.top) - fontSize / 2 - Number.parseFloat(borderWidth) + 1 + 'px'
            borderTop.style.opacity = 0

            setTimeout(() =>
            {
                if (!this.borders.left) return
                
                const borderLeftBox = this.borders.left.getBoundingClientRect()
                const d = borderLeftBox.right - label.offsetLeft
                this.borders.left.style.width = borderLeftBox.width - d + 'px'
            
                const borderRightBox = this.borders.right.getBoundingClientRect()
                const dd = borderRightBox.left - (label.offsetWidth + label.offsetLeft)
                this.borders.right.style.width = Number.parseFloat(this.borders.right.style.width) + dd + 'px'
                this.borders.right.style.left = Number.parseFloat(this.borders.right.style.left) - dd + 'px'
            }, 200)
        },

        expandLabel ()
        {
            const label = this.$el.querySelector('.label')
            const borderTop = this.borders.top

            label.style.fontSize = ''
            label.style.width = ''
            label.style.padding = ''
            label.style.marginLeft = ''
            label.style.top = this.labelInitialPos.top + 'px'
            label.style.left = this.labelInitialPos.left + 'px'
            borderTop.style.opacity = ''
            setTimeout(() => label.style.position = '', 50)
        },

        onElementClicked ()
        {
            this.errorMessage = ''
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.labelled-border
{
    border-radius: 4px;

    &.has-error
    {
        .content > .label
        {
            color: red;
        }

        > .border
        {
            border-color: red;
        }
    }

    .content > .label
    {
        color: var(--theme-text-color-extra-light);
        margin: 0 5px;
        transition: all 0.1s linear;
        font-size: 90%;
    }
    
    > .border
    {
        position: absolute;
        border: 2px solid var(--theme-border-color);
        border-radius: inherit;
        pointer-events: none;

        &.left
        {
            border-right: none;
            border-top-right-radius: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
        &.bottom
        {
            border-top: none;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
        &.right
        {
            border-left: none;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
        &.top
        {
            border-bottom: none;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }
    }

    .error-message
    {
        display: inline-block;
        color: red;
        margin-top: 5px;
        margin-left: 5px;
        font-size: 2vh;
        
        .OnLargeMobile({ font-size: 1.7vh; });
        .OnTablet({ font-size: 1.5vh; });
        .OnDesktop({ font-size: inherit; });
    }
}
</style>


// WEBPACK FOOTER //
// src/components/LabelledBorder.vue